<script>

  import { onMount } from 'svelte';
  import { setPageSettings } from '../service/LmsUIService';
  import { External, M } from '../../external';
  import ImagePicker from '../../Common/ImagePicker.svelte';
  import AccessLevelPicker from '../utils/AccessLevelPicker.svelte';
  import AvailabilityPicker from '../utils/AvailabilityPicker.svelte';
  import { pickIcon } from '../../Common/MaterialIconPicker.svelte';

  export let page,
    circleDetails,
    isTemplate,
    onChange = () => {
    };

  let pageUrl = '';
  let pageSettings = setPageSettings(page);

  let layoutInTheNavigationBarOptions = [
    { id: 'text', text: M.TEXT_ONLY },
    { id: 'number', text: M.NUMBER },
    { id: 'icon', text: M.ICON },
    { id: 'icon-large', text: M.ICON_LARGE },
    { id: 'image', text: M.IMAGE },
    { id: 'image-video', text: M.IMAGE_VIDEO }
  ];

  let pickPageIcon = async () => {
    let icon = await pickIcon();
    if (icon) {
      pageSettings.layoutIcon = icon;
      notifyChanged();
    }
  };

  let notifyChanged = () => {
    onChange();
  };

  let onSetPageUrl = () => {
    pageUrl = External.Tools.urlFromString(pageUrl, false, false, '-', true);

    let urlItems;
    if (page.groupId) {
      urlItems = [...circleDetails.groups.filter(gr => gr.pageGroup.id === page.groupId).flatMap(gr => gr.pages)];
    } else {
      urlItems = [
        ...circleDetails.pages,
        ...circleDetails.groups.map(gr => gr.pageGroup)
      ];
    }

    // it's fine comparing group and page ids... IDs are UUIDs
    if (urlItems.filter(i => i.id !== page.id && i.url === pageUrl).length > 0) {
      pageUrl = page.url;
      External.Tools.showError(M.PAGE_SAME_URL_EXISTS);
    }

    page.url = pageUrl;
    notifyChanged();
  };

  onMount(() => {
    pageUrl = page.url;
  });
</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center mt-5">
    <span class="material-icons-outlined fingerprint-icon"> settings </span>
  </div>
  <h4 class="col20 f-left mt-15 mb-25 t-center h4-bigger">{M.PAGE_SETTINGS}</h4>
  <!--<span class="light-gray-text t-center col20 f-left mb-25 padded-text">Enable your users to refer customers to your store and give them part of the sales in return.</span>-->
  <div class="popup-input-wrapper">
    <h5>{M.PAGE_NAME}</h5>
    <input type="text" name="imageDescription" placeholder={M.ENTER_DISPLAY_NAME} bind:value={page.name} on:change={notifyChanged}>
  </div>
  <div class="popup-input-wrapper">
    <h5>{M.PAGE_URL}</h5>
    <input type="text" name="circlePageURL" bind:value={pageUrl} on:change={onSetPageUrl}>
  </div>
  <div class="col20 f-left">
    <div class="checkbox-wrapper">
      <input id="toShowLensDescriptionZoom2" class="css-checkbox" type="checkbox" name="toShowLensZoom2"
             bind:checked={pageSettings.showDescription}
             on:change={notifyChanged} />
      <label for="toShowLensDescriptionZoom2" class="css-label">{M.SHOW_PAGE_DESCRIPTION}
        <span>{M.SHOW_PAGE_DESCRIPTION_DESC}</span>
      </label>
    </div>
  </div>
  {#if pageSettings.showDescription}
    <div class="popup-input-wrapper mt-5">
      <h5>{M.PAGE_DESCRIPTION}</h5>
      <input type="text" name="pageDescription" placeholder={M.ENTER_DISPLAY_DESCRIPTION} bind:value={page.description} on:change={notifyChanged}>
    </div>
  {/if}
  <!-- Hide Page -->
  <div class="checkbox-wrapper">
    <input id="hidePage" class="css-checkbox" type="checkbox" name="hidePage" bind:checked={page.hidden} on:change={notifyChanged}>
    <label for="hidePage" class="css-label">
      {M.HIDDEN_PAGE}
      <span>{M.HIDDEN_PAGE_DESC}</span>
    </label>
  </div>
  <!-- Hide Page END -->

  <div class="popup-input-wrapper f-left mt-15">
    <AccessLevelPicker {isTemplate} item="{page}" type="PAGE" onChange="{notifyChanged}" />
  </div>

  <div class="popup-input-wrapper f-left">
    <AvailabilityPicker item="{page}" circleDetails="{circleDetails}" onChange="{notifyChanged}" />
  </div>

  <div class="col20 f-left">
    <div class="checkbox-wrapper">
      <input id="toShowTrackContentCompletion" class="css-checkbox" type="checkbox" name="showTrackContentCompletion"
             bind:checked={pageSettings.trackContentCompletion} on:change={notifyChanged} />
      <label for="toShowTrackContentCompletion" class="css-label">{M.TRACK_CONTENT_COMPLETION} <span>{M.TRACK_CONTENT_COMPLETION_DESC}</span></label>
    </div>
  </div>
  <div class="popup-input-wrapper f-left mt-15">
    <div class="info">
      <h5>{M.LAYOUT_NAV_BAR}</h5>
    </div>
    <select class="page-select" bind:value={pageSettings.layout} on:change={notifyChanged}>
      {#each layoutInTheNavigationBarOptions as layoutInTheNavigationBarOption (layoutInTheNavigationBarOption)}
        <option value={layoutInTheNavigationBarOption.id}>
          {layoutInTheNavigationBarOption.text}
        </option>
      {/each}
    </select>
  </div>

  {#if pageSettings.layout === 'icon' || pageSettings.layout === 'icon-large'}

    <div class="info">
      <h5>{M.OPTION_ICON}</h5>
      <span>{M.OPTION_ICON_DESC}</span>
    </div>
    <div class="iconpicker-value mt-5" on:click={pickPageIcon}>
      {#if pageSettings.layoutIcon && pageSettings.layoutIcon.length > 20}
        <span>{@html pageSettings.layoutIcon}</span>
      {:else}
        <span class="material-icons-outlined">{pageSettings.layoutIcon}</span>
      {/if}
    </div>
  {/if}

  {#if pageSettings.layout === 'image' || pageSettings.layout === 'image-video'}
    <ImagePicker onChange={notifyChanged} bind:image={pageSettings.layoutImage} bind:imageBase={pageSettings.layoutImageBase} />
  {/if}

  <div class="col20 f-left mt-15">
    <div class="checkbox-wrapper">
      <input id="toShowBadge" class="css-checkbox" type="checkbox" name="toShowBadge" bind:checked={pageSettings.showBadge}
             on:change={notifyChanged} />
      <label for="toShowBadge" class="css-label">{M.ADD_A_BADGE} <span>{M.ADD_A_BADGE_DESC}</span></label>
    </div>
  </div>
  {#if pageSettings.showBadge}
    <div class="popup-input-wrapper mt-5">
      <h5>{M.BADGE_LABEL}</h5>
      <input type="text" name="badgeLabel" placeholder={M.ENTER_BADGE_LABEL} bind:value={pageSettings.badgeLabel} on:change={notifyChanged}>
    </div>
  {/if}
</div>
